/**
 * Figma Node IDs:
 * Design Frame: 1480:70705
 * Instance IDs: I1728:3644;944:23253, I1728:3644;944:23254, I1728:3649;944:23253, I1728:3649;944:23254, I1728:3656;944:23253, I1728:3656;944:23254, I1728:3661;944:23253, I1728:3661;944:23254, I944:23233;74:2273
 * Composite: true
 * Last Updated: 2024-12-23
 * Generated by: Claude Code figma-component command
 */
import React from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";

import { Hexagon } from "@labxchange/icons";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

import {
  tooltipTrigger,
  tooltipContentVariants,
  tooltipArrowVariants,
  contentWrapperClass,
  contentClass,
  iconClass,
  iconColorVariants,
  contentSpanClass,
} from "./Tooltip.css";

export type TooltipVariant = "dark" | "light" | "success" | "fail";

export type TooltipPlacement = "top" | "bottom" | "left" | "right";

export interface TooltipProps {
  children: React.ReactNode;
  content: string;
  variant?: TooltipVariant;
  placement?: TooltipPlacement;
  disabled?: boolean;
  delayDuration?: number;
  className?: string;
  showIcon?: boolean;
  onOpenChange?: (open: boolean) => void;
  defaultOpen?: boolean;
  equation?: boolean;
  /**
   * When true, the trigger will be the child element itself rather than a wrapper button.
   * Useful when the child already handles interactions or has specific positioning.
   */
  asChild?: boolean;
}
export const Tooltip = ({
  children,
  content,
  variant = "dark",
  placement = "top",
  disabled = false,
  delayDuration = 300,
  className,
  showIcon = false,
  defaultOpen = false,
  onOpenChange,
  equation = false,
  asChild = false,
}: TooltipProps) => {
  if (disabled) {
    return <>{children}</>;
  }

  const isStatusVariant = variant === "success" || variant === "fail";

  const iconClassName = isStatusVariant
    ? `${iconClass} ${iconColorVariants[variant as "success" | "fail"]}`
    : iconClass;
  const contentClassName = `${tooltipContentVariants[variant]}${className ? ` ${className}` : ""}`;

  const icon =
    showIcon && isStatusVariant ? (
      <span className={iconClassName}>
        <Hexagon type={variant as "success" | "fail"} />
      </span>
    ) : null;

  return (
    <RadixTooltip.Root
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      delayDuration={delayDuration}
    >
      <RadixTooltip.Trigger
        asChild={asChild}
        type={asChild ? undefined : "button"}
        className={asChild ? undefined : tooltipTrigger}
      >
        {children}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content side={placement} className={contentClassName}>
          <div className={contentWrapperClass}>
            <div className={contentClass}>
              {icon}
              <span className={contentSpanClass}>
                <RichText text={content} equation={equation} />
              </span>
            </div>
          </div>
          <RadixTooltip.Arrow className={tooltipArrowVariants[variant]} />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};
